module.exports = __webpack_public_path__ + "img/11n.360cd261.png";